// extracted by mini-css-extract-plugin
export default {"input":"SchemasSelectorView_input__rEq-t","value":"SchemasSelectorView_value__-SvH1"};